import { Popup } from './popup';

const menu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
menu.init();

const menuLinks = new Popup('#jsMenuWrap', '.jsMenuLink', '#jsCloseMenu');
menuLinks.init();

const search = new Popup('#jsSearchWrap', '#jsOpenSearch', '#jsCloseSearch');
search.init();

const user = new Popup('#jsUserWrap', '#jsOpenUser', '#jsCloseUser');
user.init();

const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
cart.init();

const videoAlt = new Popup('#jsVideoWrap', '#jsOpenVideo', '#jsVideoClose');
videoAlt.init();

const filters = new Popup('#jsfilterWrap', '#jsOpenFilters', '#jsCloseFilter');
filters.init();

const gallery = new Popup('#jsGalleryWrap', '#jsOpenGallery', '#jsGalleryClose');
gallery.init();

window.addEventListener('reset', () => {
const gallery = new Popup('#jsGalleryWrap', '#jsOpenGallery', '#jsGalleryClose');
gallery.init();
})